"use client";

import { useEffect } from "react";

export function BrowseHeartbeat({ email, productId }: { email?: string | null; productId?: number }) {
  useEffect(() => {
    if (!email) return;
    const controller = new AbortController();
    fetch("/api/browse/heartbeat", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ email, productId }),
      signal: controller.signal,
    }).catch(() => {});
    return () => controller.abort();
  }, [email, productId]);
  return null;
}
